// extracted by mini-css-extract-plugin
export var pageVideo = "ContentfulBlockVideo-module--pageVideo--BNZF9";
export var video = "ContentfulBlockVideo-module--video--58TIV";